module.exports = __webpack_public_path__ + "img/downarw.801a479c.svg";